import React from "react";
import { View, Image, StyleSheet, Dimensions } from 'react-native';
import star_y from '../assets/icon/star_yellow.png'
import star_g from '../assets/icon/star_grey.png'
import { CaptionNormalDark, Progress, SubheaderNormalDark, ComponentSeeAll } from ".";
import { global } from "../const";

const { width } = Dimensions.get("window");

export default function ProgressStrength({ progress, start, end, title, onPress }) {
    
    return (
        <View>
            <View style={styles.progressHeading}>
                <SubheaderNormalDark title={title}/>
                <ComponentSeeAll onClick={onPress} />
            </View>

            <View style={styles.container}>

                <View style={styles.progressIcon}>
                    <Image source={star_y} style={styles.iconImage} resizeMode="contain"/>
                </View>
                
                <View style={{ width: !global.isNative ? "75%" : width*0.7 }}>
                    <Progress progress={(progress / 10) + "%"} />
                </View>

                <View style={styles.progressIcon}>
                    <Image source={star_g} style={styles.iconImage} resizeMode="contain"/>
                </View>

            </View>
            <View style={{ justifyContent: 'space-between', flexDirection: 'row' }}>
                <CaptionNormalDark title={start}/>
                <CaptionNormalDark title={end}/>
            </View>
        </View>
    )
}


const styles = StyleSheet.create({
    container: {
        flexDirection: 'row', 
        width: '100%', 
        alignItems: 'center', 
        justifyContent: 'center'
    },
    progressIcon: {
        width: global.isNative ? width*0.1 : "15%",
        height: global.isNative ? width*0.1 : "15%",
        alignItems: 'center', 
        justifyContent: 'center',
    },
    iconImage: {
        height: 24,
        width: 24
    },
    progressHeading: {
        paddingBottom: 15,
        justifyContent: 'space-between',
        alignItems: 'center',
        flexDirection: 'row'
    },

})